// src/app/context/SearchContext.js
import React, {
  createContext,
  useContext,
  useState,
  useCallback,
} from "react";

const SearchContext = createContext(null);

const DEFAULT_STATE = {
  destination: "",
  startDate: "",
  endDate: "",
  adults: 0,
  children: 0,
  babies: 0,
};

export function SearchProvider({ children }) {
  const [search, setSearch] = useState(DEFAULT_STATE);

  const updateSearch = useCallback((patch) => {
    setSearch((prev) => ({ ...prev, ...patch }));
  }, []);

  return (
    <SearchContext.Provider value={{ search, updateSearch }}>
      {children}
    </SearchContext.Provider>
  );
}

export function useSearch() {
  const ctx = useContext(SearchContext);
  // on ne jette plus d'erreur → ça évite ton "useSearch doit être utilisé..."
  if (!ctx) {
    return {
      search: DEFAULT_STATE,
      updateSearch: () => {},
    };
  }
  return ctx;
}
